import { useEffect } from "react";

const DEFAULT_OG_IMAGE = "https://hrajbonus.com/img/hrajbonus-logo.webp";
const SITE_NAME = "HrajBonus";

interface SEOProps {
  title: string;
  description: string;
  url?: string;
  robots?: string;
  image?: string;
}

function setMeta(selector: string, attr: string, value: string) {
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    const parts = selector.match(/\[([^=]+)="([^"]+)"\]/);
    if (parts) el.setAttribute(parts[1], parts[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setCanonical(href: string) {
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, url, robots = "index, follow", image }: SEOProps) {
  useEffect(() => {
    const canonicalUrl = url || window.location.origin + window.location.pathname;
    const ogImage = image || DEFAULT_OG_IMAGE;

    document.title = title;

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[name="robots"]', "content", robots);

    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", canonicalUrl);
    setMeta('meta[property="og:image"]', "content", ogImage);
    setMeta('meta[property="og:site_name"]', "content", SITE_NAME);

    setMeta('meta[name="twitter:card"]', "content", "summary");
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", ogImage);

    setCanonical(canonicalUrl);
  }, [title, description, url, robots, image]);
}
